module.exports = __webpack_public_path__ + "static/media/24UHCHR8.49b55916.jpg";